module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-740.dc439e2a.jpg";